import { motion } from 'framer-motion'
import { PlatformFlow } from './platform-flow'

export function Platform() {
    return (
        <section
            id="platform"
            className="py-20 px-6 md:px-12 lg:px-16"
        >
            <div className="w-full max-w-7xl mx-auto">
                {/* Section Header */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="text-center mb-12"
                >
                    <span className="inline-block font-body text-xs uppercase tracking-widest text-muted-foreground border border-border rounded-full px-4 py-1.5 mb-6">
                        Platform
                    </span>
                    <h2 className="font-heading text-4xl md:text-5xl text-foreground mb-4">
                        From hire to revenue<br />in one platform.
                    </h2>
                    <p className="font-body text-lg text-muted-foreground font-light max-w-2xl mx-auto">
                        Click through how a worker goes from idle to shipping — sourcing leads, running campaigns, and reporting back.
                    </p>
                </motion.div>

                {/* Tabbed product flow */}
                <PlatformFlow />
            </div>
        </section>
    )
}

